import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createHead } from '@vueuse/head'; // Import createHead
import "./firebaseConfig";
import { createGtag } from 'vue-gtag'; // Import createGtag, as it's a named export

const app = createApp(App);
const head = createHead();

app.use(router);
app.use(head); // Use the head plugin
app.use(createGtag({ // Use createGtag
  config: { id: 'G-CCTBQSWN85' } // Your Google Analytics Measurement ID
}));

app.mount('#app');